import React from "react";

import Box from "@mui/material/Box";
import { CssBaseline } from "@mui/material";

import SharedEpisodesView from "../modules/SharedEpisodes/SharedEpisodesView";

export default function SharedEpisodes() {
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <SharedEpisodesView />
    </Box>
  );
}
